module.exports = __webpack_public_path__ + "img/myIcon.3272477d.svg";